import { ChartDataColor } from "../models/general/chart-data-color.model";
import { QuestionCategory } from "../models/question-category.model";
import { ColorHelper } from "./color.helper";

export abstract class ReportHelper {
    public static colors: string[] = ['#433696', '#17a5e3', '#F09443', '#2B9443', '#D94646', '#335AD6'];

    public static catOrders = {
        'MOT' : ['MOT001', 'MOT002', 'MOT003', 'MOT004', 'MOT005', 'MOT006', 'MOT007', 'MOT008', 'MOT009'],
        'VIS' : ['VIS001', 'VIS002', 'VIS003', 'VIS004', 'VIS005', 'VIS006', 'VIS007'],
        'COM' : ['COM001', 'COM002', 'COM003', 'COM004'],
        'CONF': ['CONF005', 'CONF004', 'CONF001', 'CONF003', 'CONF002']
    };

    public static getChartLegendColor(index: number, alpha?: number): ChartDataColor {
        return ColorHelper.getChartLegendColor(ReportHelper.colors, index, alpha);
    }

    public static sortByCategories<T>(category: QuestionCategory, profiles: T[], field: string): T[] {
        return profiles.sort((a, b) => {
          const pOrder = ReportHelper.catOrders[category.code] as string[];
          return pOrder.indexOf(a[field]) - pOrder.indexOf(b[field]);
        });
    }
}